import { useEffect, useState } from "react";
import Input from "../Form/Input";
import Textarea from "../Form/Textarea";
import Checkbox from "../Form/Checkbox";
import RadiosLabel from "../Form/RadiosLabel";
import Button from "../Form/Button";
import ImageUploadPreview from "../Form/ImageUploadPreview";
import SelectTag from "../Form/SelectTag";
import PreviewProduct from "../Elements/PreviewProduct";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { addProduct, editProduct, listProductIngredient } from "../../helpers/api_helper";
import { toast } from "react-toastify";
import { Loading } from "../Elements/Loading";

// function useAddon() {
//   return useQuery({
//     queryKey: ["addon_dropdown"],
//     queryFn: async () => {
//       let tmp = [];
//       const { data } = await axios.post(
//         `${hostUrl}/v2/products/list`,
//         {
//           product_type: 2,
//           limit: 9999,
//         },
//         {}
//       );

//       data.data.forEach((item) => {
//         tmp.push({ value: item._id, label: item.title });
//       });

//       return tmp;
//     },
//   });
// }

const AddFood = ({ modalClose, details, isCombo, isFetching, queryProduct }) => {
  const queryClient = useQueryClient();

  const diets = queryClient.getQueryData(["diets"]);
  const category = queryClient.getQueryData(["categories_dropdown"]);
  const allergy = queryClient.getQueryData(["allergy_dropdown"]);
  const spiceLvl = queryClient.getQueryData(["spice_level_dropdown"]);

  function useSpice() {
    return useQuery({
      queryKey: ["spice_level_dropdown"],
      queryFn: async () => {
        let tmp = [];
        const { data } = await listProductIngredient(
          {
            status: true,
            type: 2,
            limit: 9999,
          })

        data.forEach((item) => {
          tmp.push({label: item.title, value: item._id});
        });

        return tmp;
      },
    });
  }

  const { data: spices } = useSpice();

  // const { data: addon } = useAddon();

  
  const [dietData, setDietData] = useState([]);

  useEffect(() => {
    let a = [];
    diets &&
      diets.forEach((item) => {
        if (item._id !== "") {
          a.push({ _id: item._id, label: item.name, inputName: "diet" });
        }
      });
    setDietData(a);
  }, [diets]);



  const [isPreview, setIspreview] = useState(false);
  const [title, setTitle] = useState("");
  const [productId, setProductId] = useState("");
  const [regular_price, setRegular_price] = useState("");
  const [sale_price, setSale_price] = useState("");
  const [price_point, setPrice_point] = useState("");
  const [price_point_disble, setPrice_point_disable] = useState(false);
  const [plu_code, setPlu_code] = useState(Date.now());
  const [description, setDescription] = useState("");
  const [featured, setFeatured] = useState(false);
  const [in_stock, setIn_stock] = useState(1);
  const [diet_id, setDiet_id] = useState("");
  const [status, setStatus] = useState(1); //
  const [product_category_id, setProduct_category_id] = useState([]);
  const [allergie_id, setAllergie_id] = useState([]);
  const [spice_level_id, setSpice_level_id] = useState([]);
  const [addon_id, setAddon_id] = useState([]);


  const [isSpice, setIsSpice] = useState(false);
  const [isAllergie, setIsAllergie] = useState(false);
  const [spiceOpt, setSpiceOpt] = useState([]);
  const [allergieImg, setAllergieImg] = useState([]);

  useEffect(() => {
    let a = [];
    let tmpId = []
    spices &&
      spices.forEach((item) => {
        if (item._id !== "") {
          a.push({ value: item.value, label: item.label });
          tmpId.push(item.value);
        }
      });
      setSelectedSpiceOpt(a);
      setSpice_level_id(tmpId);
  }, [spices, isSpice]);



  const [selectedCatOpt, setSelectedCatOpt] = useState([]);
  const [selectedAllergieOpt, setSelectedAllergieOpt] = useState([]);
  const [selectedAddonOpt, setSelectedAddonOpt] = useState([]);
  const [selectedSpiceOpt, setSelectedSpiceOpt] = useState([]);

  const [stockManageData, setStockManageData] = useState([
    { _id: 1, label: "In Stock", inputName: "stockManage", current: true },
    {
      _id: 2,
      label: "Sold out for today",
      inputName: "stockManage",
      current: false,
    },
    { _id: 3, label: "Out of stock", inputName: "stockManage", current: false },
  ]);

  const [publishedData, setPublishedData] = useState([
    { _id: 1, label: "Published", inputName: "publish_status", current: false },
    { _id: 3, label: "Draft", inputName: "publish_status", current: true },
  ]);


  const [uploadData, setUploadData] = useState([]);


  const openPreview = () => {
    setIspreview(!isPreview);
  };

  const previewData = [
    {
      name: title,
      image: uploadData !== [] ? uploadData[0]?.image : 'https://admin.dabbawala.iosx.in/logo.svg',
      // price: parseInt(sale_price) === 0 ? parseInt(regular_price) :  sale_price === "" ? null : sale_price,
      price: parseInt(sale_price) === 0 || sale_price === "" ? regular_price : sale_price ,
      label: in_stock === 1  ? "Order Now" : in_stock === 2 ? "Today out of stock" : "Out of stock",
      ingredients: allergieImg,
    },
  ];

// console.log(spiceOpt);
  useEffect(() => {
  const fetchSpice = async() => {
    let tmp = [];
    const { data } = await listProductIngredient(
      {
        status: true,
        type: 2,
        limit: 9999,
      })

    data.forEach((item) => {
      tmp.push({label: item.title, value: item._id});
    });
    setSpiceOpt(tmp);
  }
    
  fetchSpice();
  }, []);

  useEffect(() => {
    const fetchAllergie = async() => {
      let tmp = [];
      const { data } = await listProductIngredient(
        {
          status: true,
          type: 1,
          limit: 9999,
        })
  
      data.forEach((item) => {
        if(allergie_id.includes(item._id)){
          tmp.push({ _id: item._id, name: item.title, image: item.image});
        };
      });
      setAllergieImg(tmp);
    }
      
    fetchAllergie();
    }, [selectedAllergieOpt]);

  useEffect(() => {
    setPlu_code(Date.now());
  }, []);

  function generatePlu_code() {
    setPlu_code(Date.now());
  }

  const {mutate: submitProduct, isLoading: addLoading} = useMutation(
    (payload) => addProduct(payload),
    {
      onSuccess: (res) => {
        console.log(res);
        if (res.status === 200) {
          toast.success(res.message);
          queryClient.invalidateQueries(queryProduct);
          queryClient.removeQueries({
            queryKey: ["products"],
            type: "inactive",
          });
          setTitle("");
          setRegular_price("");
          setSale_price("");
          setPrice_point("");
          setPlu_code(Date.now());
          setDescription("");
          setFeatured(false);
          setIn_stock(1);
          setDiet_id("");
          setStatus(1);
          setProduct_category_id([]);
          setAllergie_id([]);
          setSpice_level_id([]);
          setAddon_id([]);
          setSelectedCatOpt([]);
          modalClose();
        }
        
        if (res.status === 400) {
          toast.error(res.message);
        }
      },
      onError: (res) => {
        console.log(res);
      },
    }
  );

  // console.log(addLoading);

  const {mutate: submitEditedProduct, isLoading: saveLoading} = useMutation(
    (payload) => editProduct(payload),
    {
      onSuccess: (res) => {
        console.log(res);
        if (res.status === 200) {
          toast.success(res.message);
          queryClient.invalidateQueries(queryProduct);
          queryClient.removeQueries({
            queryKey: ["products"],
            type: "inactive",
          });
          queryClient.removeQueries({
            queryKey: ["details"],
            exact: false,
          });
          setTitle("");
          setRegular_price("");
          setSale_price("");
          setPrice_point("");
          setPlu_code(Date.now());
          setDescription("");
          setFeatured(false);
          setIn_stock(1);
          setDiet_id("");
          setStatus(1);
          setProduct_category_id([]);
          setAllergie_id([]);
          setSpice_level_id([]);
          setAddon_id([]);
          setSelectedCatOpt([]);
          modalClose();
        }

        if (res.status === 400) {
          toast.error(res.message);
        }
      },
      onError: (res) => {
        console.log(res);
      },
    }
  );

  // console.log(allergieImg);

  useEffect(() => {
    if(details !== undefined){
      setProductId(details ? details._id : "");
      setTitle(details ? details.title : "");
      setDescription(details ? details.short_description : "");
      setRegular_price(details ? details.regular_price : "");
      setPrice_point(details ? details.price_point : "");
      setSale_price(details ? details.sale_price : "");
      setPlu_code(details ? details.plu_code : "");
      setDiet_id(details ? details.diet_details?._id : "")
      setIn_stock(details ? details.in_stock : true);
      setUploadData(details ? [{ _id: 1, image: details.image }] : []);
      setStatus(details ? details.status : "");
      setFeatured(false);
      setPublishedData([]);
      setStockManageData([]);
      setDietData([]);
      setIsSpice(details && details?.spice_level_list && details?.spice_level_list.length === 0 ? false : true);
      setIsAllergie(details && details?.allergie_list && details?.allergie_list.length === 0 ? false : true);

      let a = [];
      diets &&
        diets.forEach((item) => {
          if (item._id !== "") {
            a.push({ _id: item._id, label: item.name, inputName: "diet", current: details?.diet_details?.title === item.name ? true : false });
          }
        });

      let tmpCat = []
      let tmpCatID = []

      details && details.category_list?.forEach((item) => {
        tmpCatID.push(item._id);
        tmpCat.push({label: item.title, value: item._id});
      });

      
      
      let tmpSpice = []
      let tmpSpiceID = []

      details && details.spice_level_list?.forEach((item) => {
        tmpSpiceID.push(item._id);
        tmpSpice.push({label: item.title, value: item._id});
      });

      let tmpAllergie = []
      let tmpAllergieID = []

      details && details.allergie_list?.forEach((item) => {
        tmpAllergieID.push(item._id);
        tmpAllergie.push({label: item.title, value: item._id});
      });

      let tmpAddon = []
      let tmpAddonID = []

      details && details.addon_list?.forEach((item) => {
        tmpAddonID.push(item._id);
        tmpAddon.push({label: item.title, value: item._id});
      });


      setTimeout(() => {
      setFeatured(details ? details.featured : false);
      setDietData(a);

      setSelectedCatOpt(tmpCat);
      setProduct_category_id(tmpCatID);
      
      setSelectedSpiceOpt(tmpSpice);
      setSpice_level_id(tmpSpiceID);

      setSelectedAllergieOpt(tmpAllergie);
      setAllergie_id(tmpAllergieID);

      setSelectedAddonOpt(tmpAddon);
      setAddon_id(tmpAddonID);


      setPublishedData(
        details
          ? [
            {
              _id: 1,
              label: "Published",
              inputName: "publish_status",
              current: details.status === 1 ? true : false,
            },
            {
              _id: 3,
              label: "Draft",
              inputName: "publish_status",
              current: details.status === 3 ? true : false,
            },
          ]
          : []
      );

      setStockManageData(
        details
          ? [
            {
              _id: 1,
              label: "In Stock",
              inputName: "stockManage",
              current: details.in_stock === 1 ? true : false,
            },
            {
              _id: 2,
              label: "Out of stock",
              inputName: "stockManage",
              current: details.in_stock === 2 ? true : false,
            },
            {
              _id: 3,
              label: "Sold out for today",
              inputName: "stockManage",
              current: details.in_stock === 3 ? true : false,
            },
          ]
          : []
      );
    }, 500)}

    if(details === undefined){
      setPublishedData([]);
      setStockManageData([]);

      setTimeout(() => {
        setPublishedData([
          { _id: 1, label: "Published", inputName: "publish_status", current: false },
          { _id: 3, label: "Draft", inputName: "publish_status", current: true },
        ]);

        setStockManageData([
          { _id: 1, label: "In Stock", inputName: "stockManage", current: true },
          {
            _id: 2,
            label: "Sold out for today",
            inputName: "stockManage",
            current: false,
          },
          { _id: 3, label: "Out of stock", inputName: "stockManage", current: false },
        ]);

      }, 1000)
    }
    
  }, [details]);

  // console.log(selectedAllergieOpt, allergie_id);

  if (isFetching) {
    return (
      <Loading />
    )
  }

  
    return (
      <>
        <div className="px-2">
          <div className="row divide-x">
            <div className="col-lg-7">
              <div className="row">
                <div className="col-md-7">
                  <div className="mb-3">
                    <Input
                      state={title}
                      setState={setTitle}
                      label={"Product Name"}
                      inputRequired={true}
                      inputType={"text"}
                      inputPlaceholder={"Example . Pizza"}
                      inputName={""}
                    />
                  </div>
                </div>
                <div className="col-md-5">
                  <div className="mb-3">
                    <Input
                      state={plu_code}
                      setState={setPlu_code}
                      label={"PLU Code"}
                      inputRequired={true}
                      inputType={"text"}
                      inputPlaceholder={"1667303409038"}
                      inputName={""}
                      labelButtonName={"Generate"}
                      labelButtonFunction={generatePlu_code}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-4">
                  <div className="mb-3">
                    <Input
                      state={regular_price}
                      setState={setRegular_price}
                      label={"Regular Price"}
                      inputRequired={true}
                      inputType={"number"}
                      inputPlaceholder={"250 €"}
                      inputName={""}
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="mb-3">
                    <Input
                      state={sale_price}
                      setState={setSale_price}
                      label={"Sale Price"}
                      inputRequired={false}
                      inputType={"number"}
                      inputPlaceholder={"150 €"}
                      inputName={""}
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="mb-3">
                    <Input
                      state={price_point}
                      setState={setPrice_point}
                      label={"Point Sale"}
                      inputRequired={false}
                      inputType={"number"}
                      inputPlaceholder={"10"}
                      inputName={""}
                      isCheckbox={true}
                      checkboxPosition={"left"}
                      isDisabled={price_point_disble}
                      current={price_point_disble}
                      setCurrent={setPrice_point_disable}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <div className="mb-3">
                    <Textarea
                      state={description}
                      setState={setDescription}
                      label={"Description"}
                      inputRequired={true}
                      inputPlaceholder={"Write description......."}
                      inputName={""}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <div className="mb-4">
                    {stockManageData !== [] && (
                      <Checkbox
                        current={featured}
                        setCurrent={setFeatured}
                        label={"Popular"}
                        inputName={"popular_checkbox"}
                        inputRequired={true}
                      />
                    )}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-8">
                  <div className="mb-4">
                    {stockManageData !== [] && (
                      <RadiosLabel
                        setRadio={setIn_stock}
                        data={stockManageData}
                        setData={setStockManageData}
                        label={"Stock Manage"}
                        inputRequired={true}
                      />
                    )}
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="mb-4">
                    {dietData && <RadiosLabel
                      setRadio={setDiet_id}
                      data={dietData}
                      setData={setDietData}
                      label={"Diet"}
                      inputRequired={true}
                    />}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-8">
                  <div className="mb-4">
                    {publishedData && (
                      <RadiosLabel
                        setRadio={setStatus}
                        data={publishedData}
                        setData={setPublishedData}
                        label={"Status"}
                        inputRequired={true}
                      />
                    )}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-8">
                  <div className="d-flex flex-wrap gap-3">
                    {details ? <Button
                      loading={saveLoading}
                      label={"Save"}
                      functions={() =>
                        submitEditedProduct({
                          id: productId,
                          product_type: isCombo ? 4 : 1,
                          title: title,
                          plu_code: plu_code,
                          regular_price: parseFloat(regular_price),
                          sale_price: parseFloat(sale_price),
                          price_point: parseInt(price_point),
                          short_description: description,
                          featured: featured,
                          in_stock: in_stock,
                          status: status,
                          image: uploadData && uploadData[0]?.image.includes('https') ? null : uploadData[0]?.image,
                          product_category_id: product_category_id
                            ? product_category_id
                            : null,
                          allergie_id: isAllergie ? allergie_id : null,
                          spice_level_id: isSpice ? spice_level_id : null,
                          diet_id: diet_id ? diet_id : null,
                          addon_id: addon_id ? addon_id : null,
                        })
                      }
                    /> :
                    <Button
                      loading={addLoading}
                      label={"Save"}
                      functions={() =>
                        submitProduct({
                          title: title,
                          product_type: isCombo ? 4 : 1,
                          plu_code: plu_code,
                          regular_price: parseFloat(regular_price),
                          sale_price: parseFloat(sale_price),
                          price_point: parseInt(price_point),
                          short_description: description,
                          featured: featured,
                          in_stock: in_stock,
                          status: status,
                          image: uploadData ? uploadData[0]?.image : null,
                          product_category_id: product_category_id
                            ? product_category_id
                            : null,
                          allergie_id: isAllergie ? allergie_id : null,
                          spice_level_id: isSpice
                            ? spice_level_id
                            : null,
                          diet_id: diet_id ? diet_id : null,
                          addon_id: addon_id ? addon_id : null,
                        })
                      }
                    />}
                    <Button
                      label={"Cancel"}
                      classes={"main-button-alt"}
                      functions={() => {
                        modalClose();
                        queryClient.removeQueries({
                          queryKey: ["details"],
                        });
                      }}
                    />
                    <Button
                      label={"Preview"}
                      classes={"main-button-link"}
                      functions={openPreview}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-5">
              {!isPreview ? (
                <>
                  <div className="row">
                    <div className="col">
                      <ImageUploadPreview
                        setImage={setUploadData}
                        data={uploadData}
                        label={"Upload Image"}
                        inputRequired={true}
                      />
                    </div>
                  </div>
                  {isCombo ? null : <><div className="row">
                    <div className="col">
                      <div className="mb-4">
                        <SelectTag
                          selectedOptions={selectedCatOpt}
                          setSelectedOptions={setSelectedCatOpt}
                          setStateId={setProduct_category_id}
                          data={category}
                          placeholder={"Example: Product Category"}
                          label={"Product Category"}
                          inputRequired={true}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      <div className="mb-4">
                        <div className="mb-4">
                      <div className={"checkbox mb-3"}>
                        <input
                          type="checkbox"
                          name={"Allergie"}
                          className="checkbox-input"
                          // defaultChecked={isSpice ? true : false}
                          checked={isAllergie ? true : false}
                          onChange={(e) => setIsAllergie(e.target.checked)}
                        />
                        <div className="checkbox-icon"></div>
                        <div
                            className={"checkbox-label"}
                          >
                            Allergies
                          </div>
                        </div>
                        {isAllergie && <SelectTag
                        selectedOptions={selectedAllergieOpt}
                        setSelectedOptions={setSelectedAllergieOpt}
                          setStateId={setAllergie_id}
                          data={allergy}
                          placeholder={"Example: Nuts"}
                          // label={"Spice Level"}
                          inputRequired={false}
                          // isCheckbox={true}
                          // checkboxPosition={"right"}
                        />}
                      </div>
                        {/* <SelectTag
                          selectedOptions={selectedAllergieOpt}
                          setSelectedOptions={setSelectedAllergieOpt}
                          setStateId={setAllergie_id}
                          data={allergy}
                          placeholder={"Example: Allergies"}
                          label={"Allergies"}
                          inputRequired={false}
                        /> */}
                      </div>
                    </div>
                  </div></>}
                  <div className="row">
                    <div className="col">
                      <div className="mb-4">
                      <div className={"checkbox mb-3"}>
                        <input
                          type="checkbox"
                          name={"Spice Level"}
                          className="checkbox-input"
                          // defaultChecked={isSpice ? true : false}
                          checked={isSpice ? true : false}
                          onChange={(e) => setIsSpice(e.target.checked)}
                        />
                        <div className="checkbox-icon"></div>
                        <div
                            className={"checkbox-label"}
                          >
                            Spice Level
                          </div>
                        </div>
                        {/* {isSpice && <SelectTag
                        selectedOptions={selectedSpiceOpt}
                        setSelectedOptions={setSelectedSpiceOpt}
                          setStateId={setSpice_level_id}
                          data={spiceOpt}
                          placeholder={"Example: Hot Level"}
                          // label={"Spice Level"}
                          inputRequired={false}
                          // isCheckbox={true}
                          // checkboxPosition={"right"}
                        />} */}
                      </div>
                    </div>
                  </div>
                  {/* <div className="row">
                    <div className="col">
                      <div className="mb-4">
                        <SelectTag
                          setStateId={setAddon_id}
                          selectedOptions={selectedAddonOpt}
                          setSelectedOptions={setSelectedAddonOpt}
                          data={addon}
                          placeholder={"Example: Add On Products"}
                          label={"Add On Products"}
                          inputRequired={false}
                          isCheckbox={true}
                          checkboxPosition={"right"}
                        />
                      </div>
                    </div>
                  </div> */}
                </>
              ) : (
                <PreviewProduct
                  data={previewData}
                  previewClose={() => setIspreview(!isPreview)}
                />
              )}
            </div>
          </div>
        </div>
      </>
    );
  };

export default AddFood;
